import React from 'react';

import { Box, Typography } from '@mui/material';
import NavNeededIndicator from '@sharedCR/common/NavNeededIndicator';
import PropTypes from 'prop-types';

import { navigationOptionStyles } from './NavigationOption.styles';

// Option renderer for the collapsed section dropdown (tablet/mobile). Shows the
// section name and, when the section still has incomplete linked fields, the same
// "Needed" indicator the wide left-nav uses — so the per-section completeness
// signal survives the dropdown collapse instead of being dropped with the JSX label.
const NavigationOption = ({ option, optionText }) => (
  <Box sx={navigationOptionStyles}>
    <Typography data-truncated className="truncate" variant="regular16">
      {optionText}
    </Typography>

    {option.isNeeded && <NavNeededIndicator />}
  </Box>
);

NavigationOption.propTypes = {
  option: PropTypes.object.isRequired,
  optionText: PropTypes.string.isRequired,
};

export default NavigationOption;
